import {partial} from 'lodash'
import moment from 'moment'
import React from 'react'
import {Redirect} from 'react-router-dom'
import {Consumer} from '../../../context'
import views from '../../../components/calendars'
import './calendars.styl'

export default function Calendars() {
  return (<Consumer>{ (context) => {
    const {view, query, link} = context
    const View = views[view]
    const date = getDate(query)
    return View
      ? <View {...{date, view, query}} />
      : <Redirect to={link({view: 'month'}, undefined, {preserveQuery: true})} />
  }}</Consumer>)
}

function getTime(date) {
  return moment(date).toDate().getTime()
}

function getDate ({start, end}) {
  const time = (getTime(start) + getTime(end)) / 2
  return partial(moment, time)
}
